import { Link } from "react-router-dom";
import Option from '../option/option.component';

import DesignSVG from "../../vectors/design.svg";
import OptimizeSVG from "../../vectors/optimize.svg";
import MarketSVG from "../../vectors/market.svg";
import ScaleSVG from "../../vectors/scale.svg";

import './options.styles.scss';

const Options = () => {
	
	if(window.screen.width <= 1000) {
		return(
			<div className="mobile-options-container">
				<span>
					<Option icon={<DesignSVG />} text='Design' />
					<Option icon={<OptimizeSVG />} text='Optimize' />
				</span>
				<span>
					<Option icon={<MarketSVG />} text='Market' />
					<Option icon={<ScaleSVG />} text= 'Scale' />
				</span>
			</div>
		)
	} else {
		return(
			<div className="desktop-options-container">
				<Option icon={<DesignSVG />} text='Design' />
				<Option icon={<OptimizeSVG />} text='Optimize' />
				<Option icon={<MarketSVG />} text='Market' />
				<Option icon={<ScaleSVG />} text= 'Scale' />
			</div>
		)
	}
}

export default Options;
